<template>
  <div class="root-wrap">
    <div class="header-wrap">
      <Header type="light" round></Header>
    </div>
    <div class="body-wrap fx-fill">
      <div class="fill-box">
        <van-tabs v-model="activeIndex" class="fx-column" :color="$config.style.primaryColor" :scrollspy="false" :lazy-render="false" sticky :ellipsis="false" style="height: 100%;" :line-width="18">
          <van-swipe :autoplay="3000" indicator-color="white" style="background-color: #fff;padding-top: 5px;">
            <van-swipe-item v-for="item, index in bannerList" :key="index" @click="handleSwipe(item)">
              <van-image :src="$config.imgBaseUrl + item.img" width="100%" height="90"></van-image>
            </van-swipe-item>
          </van-swipe>

          <van-tab title="热映">
            <div class="movie_tab-wrap fill-box">
              <movie-list :list="hotMovieList" @buy="buyTicket" @detail="goDetail"></movie-list>
            </div>
          </van-tab>
          <van-tab title="影院">
            <div class="movie_tab-wrap fill-box fx-column">
              <screen-area @change="getCinemaList"></screen-area>
              <div class="fx-fill" style="position: relative;">
                <div class="fill-box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                  <cinema-table :list="cinemaList" @click="toCinema"></cinema-table>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="即将上映">
            <div class="movie_tab-wrap fill-box">
              <movie-list :list="futureMovieList" type="future" @detail="goDetail"></movie-list>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { movie_get_user_location } from "@/libs/map-utils.js";
import { mapGetters } from "vuex";
import { setStore, removeStore } from "@/libs/storage-utils";
import Header from "@/components/header";
import ScreenArea from "@/components/cinema/screen-area";
import MovieList from "@/components/movie/movie-list";
import CinemaTable from "@/components/cinema/cinema-table";

export default {
  data() {
    return {
      activeIndex: 0,
      hotMovieList: [],
      futureMovieList: [],
      bannerList: [],
      cinemaList: [],
      pagination: this.$config.getDefaultPagination()
    };
  },

  computed: {
    ...mapGetters([
      "position",
      "currentCityCode",
      "currentCityName",
      "currentCountyCode",
      "currentCountyName"
    ]),
    selectedLocation() {
      return this.$store.state.app.selectedLocation;
    }
  },

  watch: {
    "currentCityCode": {
      handler() {
        this.initPage();
      }
    },
    "position": {
      handler() {
        this.initPage();
      }
    }
  },

  created() {
    budo_log.debug("#92 created", location.href.split('#')[0]);
  },

  methods: {
    buyTicket(movieId, movieName) {
      this.$goPage("cinema", {
        movieId,
        movieName: movieName
      });
    },

    goDetail(movieId) {
      this.$goPage("movie-detail2", {
        movieId
      });
    },

    getHotMovieList() {
      let params = {
        citycode: this.currentCityCode
      };

      this.$service.getHotMovieList(params).then((res) => {
        this.hotMovieList = res.data ? res.data.movieList : [];
      }).catch((err) => {
        budo_log.info("#113 请求hotMovieList", err);
      });
    },

    getFutureMovieList() {
      let params = {
        citycode: this.currentCityCode,
        per: 100
      };
      this.$service.getFutureMovieList(params).then((res) => {
        this.futureMovieList = res.data ? res.data.movieList : [];
      }).catch((err) => {
        budo_log.info("#126 请求future", err);
      });
    },

    getCinemaList(refresh) {
      if (refresh) {
        this.cinemaList = [];
        this.pagination = this.$config.getDefaultPagination();
      }

      let params = {
        citycode: this.currentCityCode,
        countycode: this.currentCountyCode,
        countyName: this.currentCountyName,
        longitude: this.position ? this.position.lng : "",
        latitude: this.position ? this.position.lat : "",
        page_no: this.pagination.current_page
      };

      this.$service.get_cinema_list(params).then((res) => {
        this.cinemaList = this.cinemaList.concat(res.data.cinemaList);
        this.pagination = res.data.pagination;
      }).catch((err) => {
        budo_log.info("#144 请求影院", err);
      });
    },

    getBannerList() {
      let params = {
        type: "newwap",
        device: "wxmicro",
        citycode: this.currentCityCode
      };

      budo_log.debug("#166 getBannerList", params)
    },

    handleSwipe(item) {
      this.$goPage("cinema", {
        movieId: item.relateid
      });
    },

    loadMore() {
      budo_log.debug("#181 getCinemaList, loadMore", this.pagination)

      if (this.pagination.next) {
        ++this.pagination.current_page;
        this.getCinemaList();
      }
    },

    toCinema(cinemaId) {
      this.$goPage("movie-session", {
        cinemaId
      });
    },

    buildPageParams() {
      let params = this.$route.query;
      if (params.flag) {
        //是否使用新的支付页面 flag = new 表示使用新的
        setStore("newPayFlag", params.flag);
      } else {
        budo_log.info("#183 homeIndex -> remove newPayFlag");
        removeStore("newPayFlag");
      }
    },

    initPage() {
      this.pagination = this.$config.getDefaultPagination();
      this.getBannerList();
      this.getHotMovieList();
      this.getFutureMovieList();

      // 加载第一页影院
      this.getCinemaList(true);
    }
  },

  mounted() {
    this.initPage();

    this.$store.commit("setSelectedCounty", null);

    // 进行签名的时候  Android 不用使用之前的链接， ios 需要
    const signLink =  /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl;
    movie_get_user_location(signLink);
  },

  components: {
    Header,
    MovieList,
    ScreenArea,
    CinemaTable
  }
};
</script>

<style lang="scss" scoped>
.body-wrap {
  position: relative;

  /deep/ .van-tabs__wrap {
    height: 30px;
  }

  /deep/ .van-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;

    .van-tab__pane {
      flex: 1;
      position: relative;
    }
  }
}

.footer-wrap {
  padding-top: 50px;
}
</style>
